import { render } from "./DraftExamComposer.vue?vue&type=template&id=6a474d1d&scoped=true"
import script from "./DraftExamComposer.vue?vue&type=script&lang=js"
export * from "./DraftExamComposer.vue?vue&type=script&lang=js"

import "./DraftExamComposer.vue?vue&type=style&index=0&id=6a474d1d&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a474d1d"]])

export default __exports__